import { Numeric2BoxIcon } from './Numeric2BoxIcon';

/**
 * author: Google
 * id 0F35B058-84BF-42A1-8EC2-4DF8A5F2CB6D
 * name numeric-2-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-2-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LooksTwoIcon = Numeric2BoxIcon;
export default LooksTwoIcon